import { render } from "./Roadmap.vue?vue&type=template&id=61a6f5a9&scoped=true"
import script from "./Roadmap.vue?vue&type=script&lang=js"
export * from "./Roadmap.vue?vue&type=script&lang=js"

import "./Roadmap.vue?vue&type=style&index=0&id=61a6f5a9&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a6f5a9"]])

export default __exports__